import { render, staticRenderFns } from "./SchemaSelectArrConfig.vue?vue&type=template&id=64e991a6"
import script from "./SchemaSelectArrConfig.vue?vue&type=script&lang=js"
export * from "./SchemaSelectArrConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports